import { call, put, takeLatest } from "redux-saga/effects";
import { eLichSuNapDuLieuActionIds, ILichSuNapDuLieuActionTypes } from "../../action-types/quan-ly-dang-ky/ILichSuNapDuLieuActions";
import { IBaseRespone } from "../../../model/respone/IBaseRespone";
import { rootActions } from "../../actions/rootActions";
import { lichSuNapDuLieuCongDangKyApi } from "../../../api/cong-dang-ky/lichSuNapDuLieuCongDangKyApi";

const mainAction = rootActions.quanLyDangKy.lichSuNapDuLieu;

export function* lichSuNapDuLieuSaga(): any {
    yield takeLatest(eLichSuNapDuLieuActionIds.LOAD_START, loadWorker);
}

function* loadWorker(action: ILichSuNapDuLieuActionTypes): any {
    const idQuyDinh = action.payload as number;
    const res: IBaseRespone = yield call(lichSuNapDuLieuCongDangKyApi.SelectByQuyDinhId, idQuyDinh);
    if (res.is_success) {
        yield put(mainAction.LOAD_SUCCESS(res.data));
    } else {
        yield put(mainAction.LOAD_ERROR(res.message ?? "Có lỗi"));
    }
}